import Vue                  from "vue";
import { mapGetters }       from "vuex";
import { ErrorLogService, 
    NewsService }           from "@/services/";
import { formatDateTime, 
    stringHelper }          from "@/components/mixins";
import moment               from "moment";
import { NewsStory, 
    NewsSummary }           from "@/components/News";
import { NewsStories }      from "@/components/News/NewsStories" 
import { NewsSideMenu } from "@/components/SubMenus";
import { brandAndRegionAuthHelper } from "@/components/mixins"

export default Vue.extend({
    name: "News",
    components: {
        NewsStory,
        NewsSummary,
        NewsSideMenu,
        NewsStories
    },
    mixins: [formatDateTime, stringHelper, brandAndRegionAuthHelper],
    created() {
        this.storyId = this.$route.query.queryStoryId;
        if (this.storyId){
            this.isNewsStories = false;
            this.isNewsStory = true;
            this.getNewsStory();
        }
        this.getActveNewsStories();
    },
    computed: {
        ...mapGetters(["user", "getContentItem"]),
    },
    data: () => ({
        newsStory: {},
        newsStories: [],
        isNewsStories: true,
        isNewsStory: false,
        isLoadingNewsStories: false,
        isLoadingNewsStory: false,
        storyId: 0
    }),
    methods: {
        async getNewsStory() {
            this.isLoadingNewsStory = true;
            try {
                let result = await NewsService.getNewsStoryById(this.storyId);
                this.newsStory = result;
            } catch (err) {
                ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.isLoadingNewsStory = false;
            }
        },
        async getActveNewsStories() {
            try {
                this.isLoadingNewsStories = true;
                let result = await NewsService.getAllActiveNewsStories();
                result = result.filter(ns =>
                    this.IsBrandRegionAuthorized(ns.BrandAuthorization, ns.Region)
                    );
                this.newsStories = result;
            } catch (err) {
                ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.isLoadingNewsStories = false;
            }
        },
        async getNewsStoriesByCategoryId(categoryId: number) {
            this.isLoadingNewsStories = true;
            this.isNewsStories = true;
            this.isNewsStory = false;
            try {
                let result = await NewsService.getNewsStoriesByCategoryId(categoryId);
                result = result.filter(ns =>
                    this.IsBrandRegionAuthorized(ns.BrandAuthorization, ns.Region)
                    );
                this.newsStories = result;
            } catch (err) {
                ErrorLogService.LogAndGetErrorMessage(err);
            } finally {

                this.isLoadingNewsStories = false;
            }
        },
        loadNewsStory(storyId : number) {
            this.storyId = storyId;
            this.isNewsStories = false;
            this.isNewsStory = true;
            this.getNewsStory() 
        }
    },
    watch: {},
});
